import { render, staticRenderFns } from "./super_sidebar_toggle.vue.js?vue&type=template&id=3a22f39f!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_sidebar_toggle.vue?vue&type=template&id=3a22f39f"
import script from "./super_sidebar_toggle.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_sidebar_toggle.vue?vue&type=script&lang=js"
export * from "./super_sidebar_toggle.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_sidebar_toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a22f39f')) {
      api.createRecord('3a22f39f', component.options)
    } else {
      api.reload('3a22f39f', component.options)
    }
    module.hot.accept("./super_sidebar_toggle.vue.js?vue&type=template&id=3a22f39f!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./super_sidebar_toggle.vue?vue&type=template&id=3a22f39f", function () {
      api.rerender('3a22f39f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/super_sidebar_toggle.vue"
export default component.exports